import {MutationTree} from 'vuex';
import {ConversationsState} from '@/store/modules/Conversations/state';
import {MessageAuthor} from '#/User';
import {AdvertConversationAPI} from '#/Advert';
import {Conversation, LastMessageConversation} from '#/Conversations';

export const mutations: MutationTree<ConversationsState> = {
    ADD_NEW_MESSAGE: (
        state: ConversationsState,
        message: {
            author: MessageAuthor;
            content: string;
            id: number;
            recipient: MessageAuthor;
            sentAt: Date;
        },
    ): void => {
        state.conversation.messages.push(Object.assign({readAt: null}, message));
    },

    GET_ADVERTS_CONVERSATION: (state: ConversationsState, advertsConversation: AdvertConversationAPI[]): void => {
        state.advertsConversation = advertsConversation.map(conversation => ({
            ...conversation,
            lastUpdate: new Date(conversation.lastUpdate),
        }));
    },

    GET_CONVERSATION: (state: ConversationsState, conversation: Conversation): void => {
        state.conversation = Object.assign({}, conversation);
    },

    GET_CONVERSATIONS: (
        state: ConversationsState,
        {id, conversations}: {
            id: number;
            conversations: LastMessageConversation[];
        },
    ): void => {
        if (state.conversations[id] === undefined) {
            state.conversations[id] = [];
            conversations.forEach(conversation => {
                state.conversations[id].push(Object.assign({}, conversation));
            });
        } else {
            state.conversations[id].splice(0, state.conversations[id].length);
            conversations.forEach(conversation => {
                state.conversations[id].push(Object.assign({}, conversation));
            });
        }
    },

    HAVE_A_NEW_MESSAGE: (state: ConversationsState, newNumber: number): void => {
        state.messageUnreadNumber = newNumber;
    },
};
